import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { ComuniComponent } from '../../../../admin/comuni/comuni.component';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Model } from 'src/app/models/model';
import { Comune } from 'src/app/models/comune';
import { takeUntil } from 'rxjs/operators';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => ComunePickerComponent) },
  ],
  selector: 'comune-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class ComunePickerComponent extends ExternalSelectorComponent {

  @Input() multipleSelection = false;
  onChange: any;

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(ComuniComponent, { 
      data: { 
        selectionMode: !this.multipleSelection,
        multipleSelection: this.multipleSelection,
        showReset: true
      }
    }).afterClosed();
  };

  /** Aggiungiamo il formcontrol "nome".
   * Questa aggiunta serve perchè il form del fabbricato
   * deserializza ad ogni value changes il fabbricato;
   * se non c'è il nome nel comune ma solo humanIdentifier dopo si vede il control vuoto ma con la label fluttuante.
   */
  parts: FormGroup = this.fb.group({
    id: [''],
    humanIdentifier: ['',],
    nome: ['',],
  });

  query: FormGroup = this.fb.group({
    states: new FormArray([])
  });

  registerOnChange(onChange: (value: Model | null) => void): void {
    if (this.multipleSelection) {
      this.query.valueChanges.pipe(
        takeUntil(this.destroy),
      ).subscribe((value) => { 
        if (value.states) onChange(value.states);
      });
    } else {
      this.parts.valueChanges.pipe(
        takeUntil(this.destroy),
      ).subscribe((value) => {
        if (value.id) {
          onChange(value);
        } else {
          onChange(null);
        }
      });
    }
  }

  public writeValue(value?: any): any {
    if (value === null || value === undefined) {
      this.parts.reset();
      const statesArray = this.query.get('states') as FormArray;
      statesArray.clear();
      this.stateChanges.next();
    }
    else if (this.multipleSelection) {
      const states = new FormArray(value.map(item => new FormControl(item.id)));
      
      this.parts.patchValue({ 
        humanIdentifier: value.map(item => item.humanIdentifier || item.nome).join(', '),
        id: value.map(item => item.id)
      });
      
      this.query.setControl('states', states);
      this.stateChanges.next();
    } else {
      if (value && typeof value === 'object') {
        this.parts.patchValue({
          humanIdentifier: value.humanIdentifier || value.nome || '',
          id: value.id,
          nome: value.nome || ''
        });
      } else {
        this.parts.patchValue({
          humanIdentifier: '',
          id: value,
          nome: ''
        });
      }
      this.stateChanges.next();
    }
  }

  protected handleSelection(selectedValue: any): void {
    if (selectedValue) {
      if (this.multipleSelection) {
        this.writeValue(selectedValue);
      } else {
        const comune = new Comune().deserialize(selectedValue);
        this.writeValue(comune);
        
        if (this.onChange) {
          this.onChange(comune);
        }
      }
    }
  }
}
